export default __webpack_public_path__ + "static/media/popover.0dc55141.png";